module.exports = __webpack_public_path__ + "static/img/banner2.9048cd45.png";